import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/clubs`;
const token = localStorage.getItem("token");

/// GET
// Fonction pour récupérer tous les clubs
export const getClubs = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allclubs`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des clubs:", error);
  }
};

// Fonction pour compter les clubs
export const countClubs = async () => {
  try {
    const response = await axios.get(`${apiUrl}/countclubs`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du comptage des clubs:", error);
  }
};

// Fonction pour récupérer un club par son id
export const getClubById = async (clubId) => {
  try {
    const response = await axios.get(`${apiUrl}/${clubId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement du club:", error);
  }
};


// Fonction pour afficher le club de l'utilisateur connecté
export const getClubByUser = async (userId) => {
  try {
    const response = await axios.get(`${apiUrl}/user/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement du club de l'utilisateur:", error);
  }
};

// Fonction pour récupérer les clubs par enseignant
export const getClubByTeacher = async (teacherId) => {
  try {
    const response = await fetch(`${apiUrl}/teacher/${teacherId}`);
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Erreur serveur.");
    return data;
  } catch (error) {
    console.error("❌ Erreur lors de la récupération du club :", error);
    return null;
  }
};

/// POST
// Fonction pour créer un club
export const createClub = async (clubData) => {
  try {
    await axios.post(`${apiUrl}/createclub`, clubData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Erreur lors de la création du club:", error);
  }
};

/// PUT
// Fonction pour mettre à jour un club
export const updateClub = async (clubId, clubData) => {
  try {
    await axios.put(`${apiUrl}/updateclub/${clubId}`, clubData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Erreur lors de la mise à jour du club:", error);
  }
};

/// DELETE
// Fonction pour supprimer un club
export const deleteClub = async (clubId) => {
  try {
    await axios.delete(`${apiUrl}/deleteclub/${clubId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Erreur lors de la suppression du club:", error);
  }
};
